/**
 * Estimated WhatsApp Cloud API per-delivered-message prices (Meta, Brazil).
 * Values are approximations for display purposes only — actual billing is
 * done by Meta and may vary by volume tier and destination country.
 *
 * @see https://developers.facebook.com/documentation/business-messaging/whatsapp/pricing
 */
export const WHATSAPP_BRL_PRICES = {
  MARKETING: 0.3125,
  UTILITY: 0.04,
  AUTHENTICATION: 0.1575,
  SERVICE: 0,
};

export const estimatedTemplatePrice = category =>
  WHATSAPP_BRL_PRICES[category?.toUpperCase()] ?? null;

export const formatEstimatedPrice = value => {
  if (value === null || value === undefined) return '';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(value);
};
